export default "__VITE_ASSET__CsJxV1NF__"